/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {computeDisclosureSyncValue} from '../api'

 export const useQueryComputeDisclosureSyncValue = createReactQueryHook('computeDisclosureSyncValue', computeDisclosureSyncValue)
